import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};
  z-index: 999;
`;

const MenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 300px;
  height: 100%;
  background-color: #fff;
  box-shadow: 2px 0 5px rgba(0,0,0,0.1);
  transform: ${(props) => (props.$isOpen ? 'translateX(0)' : 'translateX(-100%)')};
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
  padding-top: 60px;
`;

const CloseButton = styled.div`
  font-size: 1.5em;
  cursor: pointer;
  align-self: flex-end;
  margin-bottom: 20px;
`;

const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1;

  li {
    margin: 15px 0;
    font-size: 1.2em;
    cursor: pointer;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: #EAE0DF; /* A light tint of the brand hover color for dark backgrounds */
    }
  }
`;

const Footer = styled.div`
  margin-top: auto;
  font-size: 0.8em;
  color: #ccc;

  input {
    width: 100%;
    padding: 10px;
    margin-top: 10px;
    border: none;
    border-radius: 5px;
  }

  button {
    margin-top: 10px;
    width: 100%;
    padding: 10px;
    border: none;
    background: #fff;
    color: #333;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;

    &:hover {
      background: #543230;
      color: #fff;
    }
  }
`;

const SideMenu = ({ isOpen: $isOpen, onClose }) => {
  const navigate = useNavigate(); // Hook to navigate between pages

  const handleNavigation = (path) => {
    navigate(path);
    onClose(); // Close menu after navigating
  };

  return (
    <>
      <Overlay $isOpen={$isOpen} onClick={onClose} />
      <MenuContainer $isOpen={$isOpen}>
        <CloseButton onClick={onClose}>×</CloseButton>
        <MenuList>
          <li onClick={() => handleNavigation('/')}>Shop</li>
          <li onClick={() => handleNavigation('/collections')}>Collections</li>
          <li onClick={() => handleNavigation('/lookbook')}>SS25 Lookbook</li>
          <li onClick={() => handleNavigation('/')}>Staples</li>
        </MenuList>
        <Footer>
          <p>Privacy Policy</p>
          <p>Instagram</p>
          <input type="email" placeholder="Enter your email" />
          <button>Subscribe</button>
        </Footer>
      </MenuContainer>
    </>
  );
};

export default SideMenu;
